module.exports = __webpack_public_path__ + "img/logo-g.edffd5e1.png";